import React from 'react';

const Disclaimer1 = () => {

	return (
		<p className="disclaimer disclaimer1">By lodging your details here, you agree that Exetel may contact you with information about our services. Learn about how we handle your <a href="https://files.exetel.com.au/terms/ExetelPrivacyPolicy.pdf" target="_blank">private information</a>.</p>
	);

};

export default Disclaimer1;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/Disclaimer1.js